import React from 'react'

const HistoricalTipoBimLinkContent = ({ data }) => {
  return (
    <>
      <div className="historical-tipo-bimlink-description">
        <p className="f-size-14">
          Otros proyectos donde este tipo ha sido vinculado con algún bimlink:
        </p>
      </div>
      <div className="p-4">
        {data.data.length === 0 ? (
          <p className="not-historical-data-found">No hay data a mostrar</p>
        ) : (
          data.data.map(item => (
            <li>
              {item.proyecto.name} - {item.bimlink.code}{' '}
            </li>
          ))
        )}
      </div>
    </>
  )
}

export default HistoricalTipoBimLinkContent
